import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './layouts/layout.component';
import { AuthGuard } from './core/guards/auth.guard';
import { Page404Component } from './shared/components/page404/page404.component';
import { LoginGuard } from './core/guards/loginGuard';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./core/auth/auth.module').then((m) => m.AuthModule),
    canActivate: [LoginGuard],
  },
  {
    path: '',
    component: LayoutComponent,
    loadChildren: () =>
      import('./features/features.module').then((m) => m.FeaturesModule),
    canActivate: [AuthGuard],
  },
  // { path: 'configuration', component: LayoutComponent, loadChildren: () => import('./features/configuration/configuration.module').then(m => m.ConfigurationModule), canActivate: [AuthGuard] },
  // { path: 'masters', component: LayoutComponent, loadChildren: () => import('./features/masters/masters.module').then(m => m.MastersModule), canActivate: [AuthGuard] },

  { path: '**', component: Page404Component },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
